import './index.css';

function TimeSavedWidget({ totalIdeas }) {
  const avgManualTimePerIdeaMin = 10;       // manual writing time in minutes
  const aiGenTimePerIdeaMin = 2 / 60;       // 2 seconds in minutes

  const totalIdeasCount = totalIdeas?.length || 0;
  const timeSavedPerIdeaMin = avgManualTimePerIdeaMin - aiGenTimePerIdeaMin;
  const totalTimeSavedMin = totalIdeasCount * timeSavedPerIdeaMin;

  const hours = Math.floor(totalTimeSavedMin / 60);
  const minutes = Math.round(totalTimeSavedMin % 60);

  return (
    <div
      className={ totalIdeasCount > 0 ? "time-saved-widget tiny-text" : "time-saved-widget tiny-text hide-me"}>
      Time Saved: {hours > 0 ? `${hours}h ` : ''}{minutes}m (based on {totalIdeasCount} ideas)
    </div>
  );
}

export default TimeSavedWidget;
